import { pushVisit } from '../../api';
import fetchCurrentTime from '../../api/fetchCurrentTime';
import { DocProfileResponse } from '../../api/fetchDoctorProfile';
import { MyClinic } from '../../api/fetchMyProfile';
import { getTemplates } from '../../store/idbHandler';
import { Clinic } from '../../store/types/prescription';
import { track } from '../../tracking';

const TIME_DIFF_THRESHOLD = 5 * 60 * 1000;
const TIMEZONE_OFFSET = -330;

export const checkTime = async (): Promise<{
    diff: string;
    timeZone: string;
    status: string;
    name: string;
}> => {
    const timeZone = new Date().getTimezoneOffset();
    return fetchCurrentTime()
        .then((res) => {
            const diff = new Date().getTime() - res.time;

            if (Math.abs(diff) > TIME_DIFF_THRESHOLD || timeZone !== TIMEZONE_OFFSET) {
                return Promise.reject({
                    diff: diff.toString(),
                    timeZone: timeZone.toString(),
                    status: 'fail',
                    name: 'time_check',
                    tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
                });
            }
            return {
                diff: diff.toString(),
                timeZone: timeZone.toString(),
                status: 'pass',
                name: 'time_check',
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            };
        })
        .catch((err) => {
            return Promise.reject({
                diff: err.diff || 'failed to fetch server time',
                status: 'fail',
                name: 'time_check',
                timeZone: err.timeZone || timeZone,
                tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            });
        });
};

export const checkClinics = async (
    clinicsLength?: number,
): Promise<{ clinics: string; status: string; name: string }> => {
    if (clinicsLength && clinicsLength !== 0) {
        return { clinics: clinicsLength.toString(), status: 'pass', name: 'clinic_check' };
    } else {
        return Promise.reject({
            clinics: clinicsLength?.toString() || 'undefined',
            status: 'fail',
            name: 'clinic_check',
        });
    }
};

export const checkPdfPreview = (
    doctor: DocProfileResponse,
): Promise<{ status: string; name: string }> => {
    const DUMMY_DATE = new Date('2020-01-01');
    if (!doctor) {
        return Promise.reject({ status: 'no doctor', name: 'pdf_preview_check' });
    }
    const clinic =
        doctor?.profile.professional?.clinics && doctor?.profile.professional?.clinics[0];

    if (!clinic) {
        return Promise.reject({ status: 'no clinic', name: 'pdf_preview_check' });
    }

    const templates = getTemplates();

    return pushVisit(
        {
            id: 'diagnosis-tool-pdf-preview',
            date: DUMMY_DATE,
            visitId: 'diagnosis-tool-dummy-visit',
            doctor: doctor,
            clinic: clinic,
            patient: {
                localId: 'diagnosis-tool-pt-id',
                profile: {
                    personal: {
                        name: 'diagnosis-user',
                        phone: {
                            c: '+91',
                            n: '0000000000',
                        },
                        gender: 'M',
                        bloodgroup: 'O+',
                    },
                },
            },
        },
        DUMMY_DATE,
        DUMMY_DATE,
        'print',
        {
            dyform: {},
        },
        {
            flag: true,
            lang: '',
        },
        templates?.print?.templateId,
        undefined,
        undefined,
        true,
    )
        .then((response) => {
            if (response.status !== 'success') {
                return Promise.reject({ status: 'fail', name: 'pdf_preview_check' });
            }
            return { status: 'pass', name: 'pdf_preview_check' };
        })
        .catch((e) => {
            console.error('pushData=>', e);
            return { status: 'fail', name: 'pdf_preview_check' };
        });
};

export const troubleshootSystem = async (doctor: DocProfileResponse): Promise<void> => {
    let timeRes;
    let clinicsRes;
    // let pdfPreviewRes;

    try {
        timeRes = await checkTime();
    } catch (err) {
        timeRes = err as { [k: string]: string };
    }
    try {
        clinicsRes = await checkClinics(doctor?.profile?.professional?.clinics?.length);
    } catch (err) {
        clinicsRes = err as { [k: string]: string };
    }

    // try {
    //     pdfPreviewRes = await checkPdfPreview(doctor);
    // } catch (err) {
    //     pdfPreviewRes = err as { [k: string]: string };
    // }

    const res = [timeRes, clinicsRes];
    let trackingObj = {};

    res.forEach((r) => {
        trackingObj = {
            ...trackingObj,
            [r.name]: JSON.stringify({ ...r }),
        };
    });
    track('DOC_DIAGNOSIS', trackingObj);
};
